<script setup lang="ts">
import { useBaseStore } from "@/stores/base";

const props = defineProps({ item: Object });
const store = useBaseStore();
</script>

<template>
	<div class="nav-item">
		<v-list-subheader
			:class="store.navigationSidebarCollapsed ? 'hidden' : ''"
			class="nav-item__text text-subtitle-2 font-weight-bold"
		>
			<span>
				{{ $t(props.item.translation_key) }}
			</span>
		</v-list-subheader>
		<v-divider thickness="1" />
	</div>
</template>

<style scoped>
.nav-item {
	display: flex;
	align-items: center;

	& .nav-item__text {
		transition: all 75ms ease;
		&.hidden {
			flex: 0;
			opacity: 0;
			min-width: 0;
			padding: 0 !important;
		}
	}
}
</style>
